import { Box } from "@mui/material";
import React from "react";
import { PdpUrlsManager } from "./PdpUrlsManager";
import { IBrand } from "../../../brand/team/data/type";

interface Props {
    video: any;
    brand: IBrand;
}

// JSON-LD and meta tags are per page × video link (desires_pdp_url_videos
// .json_ld) and managed inside PdpUrlsManager — generation only happens on
// the explicit Generate button with a pdpUrlId, never as a mount side effect.
export function SeoAioVideoPanel({ video, brand }: Props) {
    return (
        <Box
            className="flex flex-col gap-4 pb-6 pr-1 h-full overflow-y-auto"
        >
            <PdpUrlsManager video={video} brand={brand} />
        </Box>
    );
}
